<template>
  <div>
  你尚未登录，无法继续操作...
  </div>
</template>

<script>
  export default {
    data () {
      return {
      }
    }
  }
</script>
